import './index.scss'

$(document).ready(function(){
  $('.header').addClass('scroll')
})
